export default __webpack_public_path__ + "static/media/ic_bg_gift.6e68922a.svg";